import React from "react";
import _ from "lodash";

export const getName = (params) => {
  let name = "";
  const data = [];
  const node = params.node;
  const middleName = _.get(node, "middleName[0]._", "");
  if (node !== undefined) {
    name = `${node.firstName[0]._}${
      middleName !== "" ? " " : ""
    }${middleName} ${node.lastName[0]._}`;
    data.firstname = node.firstName[0]._;
    if (middleName !== "") {
      data.middlename = middleName;
    }
    data.lastname = node.lastName[0]._;
  }
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => params.handleNewSearchClick(this, "Person", name, data)}
      className={"url-link"}
    >
      {name}
    </div>
  );
};

export default getName;



// WEBPACK FOOTER //
// ./src/components/searchresults/Name.js